import React from 'react';
import { Button, Spin } from 'antd';
import axios from 'axios';
import { store } from './redux/store';
import authAction from './redux/auth/actions';

const { logout } = authAction;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, refreshing: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error);
    console.error('Error Info:', errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  // Check token, if no then logout
  handleTokenRefresh = async () => {
    this.setState({ refreshing: true });

    try {
      const accessToken = localStorage.getItem('accessToken');

      if (!accessToken) {
        store.dispatch(logout());
        return;
      }

      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_API_KEY_v2 + "/Token/RefreshToken",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          Token: accessToken,
        }),
      });

      if (response.data && response.data.RESULT) {
        localStorage.setItem("accessToken", response.data.RESULT);
        window.location.reload();
      } else {
        store.dispatch(logout());
      }
    } catch (error) {
      console.error('Token refresh failed:', error);
      store.dispatch(logout());
    } finally {
      this.setState({ refreshing: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h2>Something went wrong!</h2>
          <p>Loading failed! Please try reload the page.</p>

          {this.state.refreshing ? (
            <Spin size="large" style={{ marginTop: '20px' }} />
          ) : (
            <Button
              type="primary"
              onClick={this.handleTokenRefresh}
              style={{ marginTop: '20px' }}
            >
              Refresh
            </Button>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;